import { IconButton, SvgIconProps, Tooltip } from "@mui/material";
import { ComponentType } from "react";

export interface RCButtonProps {
  tooltipTitle: string;
  IconComponent: ComponentType<SvgIconProps>;
  onClick?: () => void;
  disabled?: boolean;
  activeColor?: string;
  inactiveColor?: string;
  customColor?: string;
  size?: string;
  placement?: "top" | "bottom" | "left" | "right";
}

export default function RCButton({
  tooltipTitle,
  IconComponent,
  onClick,
  disabled = false,
  size = "27px",
  placement = "top",
  customColor,
}: RCButtonProps) {
  return (
    <Tooltip title={tooltipTitle} placement={placement}>
      <span>
        <IconButton
          onClick={onClick}
          disabled={disabled}
          sx={{ fontSize: "large" }}
        >
          <IconComponent
            style={{
              color: customColor ?? (disabled ? "gray" : "white"),
              fontSize: size,
            }}
          />
        </IconButton>
      </span>
    </Tooltip>
  );
}
